export enum ELanguage {
    // eslint-disable-next-line no-unused-vars
    English,
    // eslint-disable-next-line no-unused-vars
    French,
}
